/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `local_retailer` - Local retailer
* `regional_retailer` - Regional retailer
* `national_retailer` - National retailer
* `retail_wholesaler` - Retail wholesaler
* `food_service_wholesaler` - Food-service wholesaler
* `restaurant` - Restaurant
* `caterer` - Caterer
* `consumer` - Consumer
 */
export type TypeOfClientsEnum = typeof TypeOfClientsEnum[keyof typeof TypeOfClientsEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TypeOfClientsEnum = {
  local_retailer: 'local_retailer',
  regional_retailer: 'regional_retailer',
  national_retailer: 'national_retailer',
  retail_wholesaler: 'retail_wholesaler',
  food_service_wholesaler: 'food_service_wholesaler',
  restaurant: 'restaurant',
  caterer: 'caterer',
  consumer: 'consumer',
} as const;
